import { render, staticRenderFns } from "./userOrganization.vue?vue&type=template&id=0938c4f0&scoped=true"
import script from "./userOrganization.vue?vue&type=script&lang=js"
export * from "./userOrganization.vue?vue&type=script&lang=js"
import style0 from "./userOrganization.vue?vue&type=style&index=0&id=0938c4f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938c4f0",
  null
  
)

export default component.exports